/* Klaviyo: Robust Added to Cart (AJAX + form) — queue = _learnq.push */
(function () {
  // ---- Güvenli temizleyiciler
  function ascii(v, max) {
    if (v == null) return '';
    v = String(v).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x20-\x7E]/g, '').trim();
    if (max && v.length > max) v = v.slice(0, max);
    return v;
  }
  function toNum(v) { var x = Number(v); return isFinite(x) ? x : undefined; }

  // ---- Klaviyo'ya gönder (yalnız _learnq.push)
  function sendAddedToCart(raw) {
    try {
      var props = {};
      props.Name      = ascii(raw.Name || raw.title || document.title, 180);
      var pid         = raw.ProductID || raw.product_id || raw.id;
      var vid         = raw.VariantID || raw.variant_id;
      if (pid) props.ProductID = ascii(pid, 80);
      if (vid) props.VariantID = ascii(vid, 80);
      var qty         = toNum(raw.Quantity || raw.quantity);
      var price       = toNum(raw.Price || raw.price || raw.$value);
      if (qty != null)  props.Quantity = qty;
      if (price != null) props.$value  = price;

      // URL / ImageURL çoğu mağazada gereksiz ve bazen reddediliyor; eklemiyoruz.
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added to Cart', props]);
      console.log('[Klaviyo] _learnq.push Added to Cart →', props);
    } catch (e) { console.log('[Klaviyo] push error', e); }
  }

  // ---- 1) fetch() interception (AJAX /cart/add.js)
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var resource = args[0], cfg = args[1];
    var url = typeof resource === 'string' ? resource : (resource && resource.url);
    var isAdd = url && url.indexOf('/cart/add') !== -1;
    return originalFetch.apply(this, args).then(function (res) {
      try {
        if (isAdd && res && res.ok) {
          res.clone().json().then(function (data) {
            // Shopify add.js: price cent cinsinden
            sendAddedToCart({
              Name: data && data.title,
              ProductID: (data && (data.product_id || data.id)),
              VariantID: data && data.variant_id,
              Quantity: data && data.quantity,
              Price: (typeof data.price === 'number') ? (data.price / 100) : undefined
            });
          }).catch(function(){});
        }
      } catch (e) {}
      return res;
    });
  };

  // ---- 2) XHR fallback (eski temalar)
  (function () {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._isAddToCart = url && url.indexOf('/cart/add') !== -1;
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this._isAddToCart) {
        this.addEventListener('load', function () {
          try {
            if (this.status >= 200 && this.status < 300 && this.responseText) {
              var data = JSON.parse(this.responseText);
              sendAddedToCart({
                Name: data && data.title,
                ProductID: (data && (data.product_id || data.id)),
                VariantID: data && data.variant_id,
                Quantity: data && data.quantity,
                Price: (typeof data.price === 'number') ? (data.price / 100) : undefined
              });
            }
          } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
  })();

  // ---- 3) Normal form submit fallback
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('form[action^="/cart/add"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var variantInput = form.querySelector('input[name="id"]');
        var qtyInput     = form.querySelector('input[name="quantity"]');
        sendAddedToCart({
          Name: document.querySelector('h1, .product__title, .product-title')?.textContent?.trim() || document.title,
          ProductID: variantInput ? variantInput.value : undefined,
          VariantID: variantInput ? variantInput.value : undefined,
          Quantity: qtyInput ? parseInt(qtyInput.value || '1', 10) : 1
          // price yok; AJAX yakalama varsa o verecek
        });
      });
    });
  });
})();
